/**
 * Enum para tipo de destino do comunicado
 */
export enum TipoDestinoEnum {
  TODOS = 1,              // Todos os usuários (ADM_SISTEMA) ou todos da imobiliária (ADM_IMOBILIARIA)
  IMOBILIARIA = 2,        // Uma imobiliária específica (apenas ADM_SISTEMA)
  USUARIO = 3             // Um usuário específico
}

export class ComunicadoRequest {
    titulo: string;
    textoComunicado: string;
    usuarioEnvioId: number;
    imobiliariaId?: number | null;       // Imobiliária destino (para IMOBILIARIA ou contexto do ADM_IMOBILIARIA)
    usuarioDestinoId?: number | null;    // Usuário específico (para USUARIO)
    tipoDestino: TipoDestinoEnum;        // Tipo de destino
    imagemBase64?: string | null;
    imagemNome?: string | null;

    constructor(p: any) {
        this.titulo = p.titulo !== undefined ? p.titulo : null;
        this.textoComunicado = p.textoComunicado !== undefined ? p.textoComunicado : null;
        this.usuarioEnvioId = p.usuarioEnvioId !== undefined ? p.usuarioEnvioId : null;
        this.imobiliariaId = p.imobiliariaId !== undefined ? p.imobiliariaId : null;
        this.usuarioDestinoId = p.usuarioDestinoId !== undefined ? p.usuarioDestinoId : null;
        this.tipoDestino = p.tipoDestino !== undefined ? p.tipoDestino : TipoDestinoEnum.TODOS;
        this.imagemBase64 = p.imagemBase64 !== undefined ? p.imagemBase64 : null;
        this.imagemNome = p.imagemNome !== undefined ? p.imagemNome : null;
    }
}